import baseService from './baseService.js';

export function getTermsAndConditions(organizationId) {
    return baseService.get(`/organizations/${organizationId}/term_and_conditions`);
}
